import { useBrand } from '@contexts/useBrand'
import { upperCaseFirst } from 'upper-case-first'

const ToggleInput = ({ onChange }) => {
  const brand = useBrand()

  const handleChange = (e) => {
    onChange(e)
  }

  return (
    <div className="block mb-4" data-gt-name="componentevent">
      <div className="mt-2">
        <div>
          <label
            htmlFor="auth"
            className="inline-flex relative items-center cursor-pointer"
          >
            <input
              type="checkbox"
              value=""
              id="auth"
              className="sr-only peer"
              data-gt-action="toggle-input-interaction"
              data-gt-label="autofill"
              onChange={(e) => {
                handleChange(e)
              }}
            />
            <div className="relative w-11 h-6 border-2 border-base peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] peer-checked:after:left-[6px] after:bg-base after:border-base after:border after:rounded-full after:h-[16px] after:w-[16px] after:transition-all"></div>
            <span className="ml-2 font-medium">
              Fill in your details from My{upperCaseFirst(brand)}?
            </span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default ToggleInput
